import { clsx, type ClassValue } from 'clsx'

/** Tiny className combiner — swap for `tailwind-merge` if conflicts arise. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs)
}
